import http from '../plugins/axios'

const resource = '/api/v1/company'

export default {
  get(uuid) {
    return http.get(`${resource}/${uuid}`)
  },
}
